// Libs
import classNames from 'classnames/bind';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Box, Grid2, Stack } from '@mui/material';
// Components, Layouts, Pages
import { BaseLabelValueField, Loading } from '~/components/common';
// Others
import { useAppDispatch } from '~/utils/redux/hooks';
import { IServiceDetail } from '~/utils/interface/service';
import { DEFAULT_NUMBER_ZERO, EMPTY_STRING } from '~/utils/constants/common';
import { formatCurrency, formatTitleCase } from '~/utils/helper/common';
import { getServiceDetail } from '~/thunks/service/serviceThunk';
import { UnitEnum, UnitValueEnum } from '~/utils/enum/common';
// Styles, images, icons
import styles from './ServiceInformation.module.scss';
import { images } from '~/assets';

type Props = {};

const cx = classNames.bind(styles);

const ServiceInformation = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/service']);
  const { id: serviceId } = useParams();
  const dispatch = useAppDispatch();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [serviceDetail, setServiceDetail] = useState<IServiceDetail>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    if (!serviceId) return;
    handleGetServiceDetail(serviceId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceId]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleGetServiceDetail = (serviceId: string) => {
    setIsLoading(true);

    dispatch(getServiceDetail(serviceId))
      .unwrap()
      .then((res) => {
        const { data } = res;
        if (!data) return;

        setServiceDetail(data);
      })
      .catch((_err) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const renderUnit = () => {
    switch (serviceDetail?.unit) {
      case UnitEnum.SQ_FT:
        return UnitValueEnum.SQ_FT;

      case UnitEnum.EACH:
        return UnitValueEnum.EACH;

      default:
        return EMPTY_STRING;
    }
  };
  //#endregion Handle Function

  return (
    <Box component={'div'} id='serviceInformationPage' className={cx('container')}>
      <Grid2 container spacing={'24px'}>
        <Grid2 size={6}>
          <BaseLabelValueField
            label={t('tab_information_name')}
            value={serviceDetail?.name ?? EMPTY_STRING}
          />

          <BaseLabelValueField
            label={t('tab_information_task_code')}
            value={serviceDetail?.taskCode ?? EMPTY_STRING}
          />

          <BaseLabelValueField
            label={t('tab_information_description')}
            value={serviceDetail?.description ?? EMPTY_STRING}
          />

          <BaseLabelValueField
            label={t('tab_information_price')}
            value={serviceDetail?.price ? formatCurrency(serviceDetail?.price) : DEFAULT_NUMBER_ZERO}
          />

          <BaseLabelValueField label={t('tab_information_unit')} value={renderUnit()} />

          <BaseLabelValueField
            label={t('tab_information_quantity')}
            // value={serviceDetail?.quantity ? formatDecimal(Number(serviceDetail?.quantity)) : EMPTY_STRING}
          />

          <BaseLabelValueField
            label={t('tab_information_taxable')}
            value={formatTitleCase(String(serviceDetail?.isTaxable))}
          />

          {/* <BaseLabelValueField
            label={t('tab_information_price_book')}
            value={serviceDetail?.priceBook?.name || EMPTY_STRING}
          /> */}

          <BaseLabelValueField
            label={t('tab_information_price_total')}
            // value={serviceDetail?.total ? formatCurrency(serviceDetail?.total) : EMPTY_STRING}
          />
        </Grid2>

        <Grid2 container direction={'column'} size={6} spacing={0} className={cx('item')}>
          <BaseLabelValueField label={t('tab_information_image')} bordered={false} labelSize={'auto'} />

          <Stack flex={1} className={cx('itemImage')}>
            {serviceDetail?.serviceImage ? (
              <img src={serviceDetail?.serviceImage} alt={t('common_alt_img')} className={cx('image')} />
            ) : (
              <img src={images.imgDefaultInventory} alt={t('common_alt_img')} className={cx('image')} />
            )}
          </Stack>
        </Grid2>
      </Grid2>
      {isLoading && <Loading />}
    </Box>
  );
};

export default ServiceInformation;
